<section
  class="b-column"
  [ngClass]="{ horizontal: horizontal, vertical: !horizontal }"
  [style.width]="horizontal ? '100%' : width"
  [style.height]="horizontal ? height : '100%'"
  [style.top]="
    horizontal
      ? columnCollapsed
        ? '100%'
        : 'calc(100% - ' + height + ')'
      : '0'
  "
  [style.left]="!horizontal && columnCollapsed ? '-' + width : '0'"
>
  <ng-content></ng-content>
  <button
    class="b-column-toggle"
    [ngClass]="{ horizontal: horizontal, vertical: !horizontal }"
    (click)="columnToggleClicked()"
  >
    <div
      [class.symbol-arrow-drop-up]="horizontal && columnCollapsed"
      [class.symbol-arrow-drop-down]="horizontal && !columnCollapsed"
      [class.symbol-arrow-right]="!horizontal && columnCollapsed"
      [class.symbol-arrow-left]="!horizontal && !columnCollapsed"
      class="toggle-arrow-icon"
    ></div>
  </button>
</section>
